<template>
	<o-card
		class="dashboard-pending-order"
		gradient="info">
		<o-icon
			font-icon="icon-interface-setting-tool-box"/>
		<div class="dashboard-pending-order">
			<h3 class="dashboard-pending-order__title">
				{{ setup.countWaiting ? `Vos offres de missions` : `Aucune offre de mission` }}
			</h3>

			<div
				v-if="setup.countWaiting"
				class="dashboard-pending-order__item">
				<p class="dashboard-pending-order__text-content">
					<span class="dashboard-pending-order__count">
						{{ setup.countWaiting }}
					</span>
					En attente
				</p>
				<o-button
					outline
					color="default"
					@click="setup.gotToJobOffers(ORDER_PROPOSAL_STATUS.Waiting)">
					Voir
				</o-button>
			</div>
		</div>

		<o-loader
			color="info"
			:visible="!setup.dataLoaded"/>
	</o-card>
</template>

<script setup lang="ts">
import DashboardPendingJobOfferCardSetupService from '@/setup/dashboard/DashboardPendingJobOfferCardSetupService';
import { ORDER_PROPOSAL_STATUS } from '@/typings/enums/ORDER_PROPOSAL_STATUS';
const setup = new DashboardPendingJobOfferCardSetupService();
</script>


<style scoped lang="less">
.dashboard-pending-order {
  height: 100%;
  position: relative;

  .orion-icon {
    position: absolute;
    top: 0.9rem;
    right: 0.9rem;
    opacity: 0.15;
    font-size: 7.5rem;
  }

  &__title {
    color: white;
    margin: 0.6rem 0 0.9rem;
    padding: 0.3rem;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.3rem;
    font-size: 0.9rem;
    line-height: 1.3rem;
    font-weight: bold;
    text-transform: uppercase;
  }

  &__count {
    transform: translateY(-0.13rem);
    margin-right: 0.6rem;
    font-size: 3.1rem;
    line-height: 1;
    font-weight: bold;
    text-shadow: 0 0.13rem 0.19rem fade(black, 20);
  }

  &__text-content {
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }
}
</style>
